import React from 'react';

import { BsInfoCircleFill } from 'react-icons/bs';

import { Container } from './styles';

const Summary: React.FC = ({ children }) => {
  return (
    <Container>
      <i>
        <BsInfoCircleFill size={32} color="#333" />
      </i>
      {children}
    </Container>
  );
};

export default Summary;
